
import React, {Component, useState, useEffect} from 'react';
import { Switch } from 'react-router';
import {Route, Redirect, withRouter, useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'underscore';

import DatabaseService from 'services/DatabaseService.js';

import RoleUtils from 'utils/RoleUtils'

import PageNotFound                   from 'modules/main/PageNotFound.js';
import DefaultLayout                  from 'modules/main/DefaultLayout.js';
import LogInContainer                 from 'modules/authentication/LogInContainer.js';
import LeaderboardContainer           from 'modules/leaderboards/LeaderboardContainer.js';


import { getUserRoles } from 'reducers/user';


const loginPath      = '/login';

const AppContent = ({isLoggedIn, dispatch, user, navbarMode, showSidebar, showNavbar}) => {
    const [init, setInit] = useState(true)
    const [appDataLoaded, setAppDataLoaded] = useState(false)
    const history = useHistory()
    const location = useLocation()

    const loadAppData = async () => {
        dispatch({type:'SET_LOADING_OVERLAY_ENABLE', enable:true});
        setAppDataLoaded(false)
        const results = await Promise.all([
            DatabaseService.getRoles(),
            DatabaseService.getRoleAllowedRoutes()
        ]).catch(async (error)=> {
            if(error.status == 401) {
                await DatabaseService.signOut()
                window.location.href = '/login'
            }
            console.error('loadAppData', error);
            dispatch({type:'SET_LOADING_OVERLAY_ENABLE', enable:false});
        })
        if (results) {
            dispatch({type:'SET_LOADING_OVERLAY_ENABLE', enable:false});
            setAppDataLoaded(true)
        }
    }

    const handleRedirects = (props) => {
        if(!localStorage.companyId &&
            location.pathname!=='/organizations' &&
            isLoggedIn) {
            history.replace('/organizations');
        }
    }

    useEffect(() => {
        // if (isLoggedIn) {
        //     loadAppData()
        // } else {
            setAppDataLoaded(true)
        //}
        handleRedirects()
    }, [isLoggedIn])

    
    return (init &&
        <DefaultLayout showNavbar={showNavbar} showSidebar={showSidebar} navbarMode={navbarMode} >
            { appDataLoaded &&
            <Switch>
                {/* <RedirectRoute exact path="/"                    component={LogInContainer}               when={isLoggedIn}  to={loginPath}/>
                <RedirectRoute path={loginPath}                  component={LogInContainer}               when={isLoggedIn}  to={loginPath}/> */}
                
                {/* <RedirectRoute path="/leaderboards/:id/:teamId"  component={LeaderboardContainer}         when={isLoggedIn} to={loginPath}  cprops={{withinTeam: true}}/> */}
                <RedirectRoute path="/leaderboards/:id"          component={LeaderboardContainer}         when={isLoggedIn} to={loginPath}/>

            </Switch>
            }
        </DefaultLayout>
    );
}

const mapRolesToProps = (state, ownProps) => {
    return { allowedRoutes : RoleUtils.getPathFilter(getUserRoles(state)) };
}

const ProtectedRoute = connect(mapRolesToProps)(({allowedRoutes, ...props}) => {
    return (
        allowedRoutes.includes('/' + props.path.split('/')?.[1])
        ? <RedirectRoute {...props} />
        : <PageNotFound />
    )
})

const RedirectRoute = ({ component: Component, when, to, preserveSearch, cprops, ...rest }) => {
  return (<Route {...rest} render={props => (
        when ? (
          <Redirect to={{
            pathname: to,
            search: (preserveSearch ? props.location.search : undefined),
            state: { from: props.location }
          }}/>
        ) : (
          <Component {...props} {...cprops}/>
        )
      )}/>
    );
}

const mapAppContentProps = (state, ownProps) => {
    return { };
}
export default withRouter(connect(mapAppContentProps)(AppContent));
